let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("72t7x")).then(() => parcelRequire('hvRQd'));